import React from "react";
import "../css/Course.css";


const Course = (props) => {

  return (
    <div className="course-container">
        <h2>{props.title}</h2>
        <p>{props.description}</p>
    </div>
  );
};

export default Course;